

import './TopNav.scss'
import {useState} from "react";

const tabs = [{
    key:'product-feature',
    name:'产品特点'
},{
    key:'product-introduce',
    name:'产品介绍'
},{
    key:'about-us',
    name:'关于我们'
}]

export default function TopNav(){
    const [tab, setTab] = useState(tabs[0].key)
    return (
        <nav className={'navbar'}>
            <ul>
                {tabs.map(t=>(
                    <li key={t.key} className={t.key===tab?'active':''} onClick={()=>setTab(t.key)}><a href={`#${t.key}`}>{t.name}</a></li>
                ))}
            </ul>
        </nav>
    )
}
